import React from 'react';
import SelectStateButton from './SelectStateButton';
import './SelectState.scss';

function SelectStateNav({
  showStates,
  handleClickSelectState,
  selectStateButtonRef,
  currentStateIndex,
  handleClickArea,
  previousStateName,
  nextStateName
}) {
  return (
    <>
      <SelectStateButton
        handleClickSelectState={handleClickSelectState}
        selectStateButtonRef={selectStateButtonRef}
        showStates={showStates}
        loc="bottom"
      />
      <div className="selectStateNav">
        <svg
          viewBox="0 0 30 54"
          className={`selectStateNav__icon selectState-${
            currentStateIndex !== 0 ? currentStateIndex - 1 : 49
          }-mobile`}
          onClick={() => {
            handleClickArea(previousStateName);
          }}
        >
          <path d="M27.1484 53.3676L1.2661 28.7279L28.756 1.05926" stroke="black" />
        </svg>
        <div
          className={`selectStateNav__section selectState-${
            currentStateIndex !== 0 ? currentStateIndex - 1 : 49
          }-mobile`}
          onClick={() => {
            handleClickArea(previousStateName);
          }}
        >
          <p
            className={`selectStateNav__text selectState-${
              currentStateIndex !== 0 ? currentStateIndex - 1 : 49
            }-mobile`}
          >
            {previousStateName}
          </p>
        </div>
        <div className="selectStateNav__divider" />
        <div
          className={`selectStateNav__section selectState-${
            currentStateIndex !== 49 ? currentStateIndex + 1 : 0
          }-mobile`}
          onClick={() => {
            handleClickArea(nextStateName);
          }}
        >
          <p
            className={`selectStateNav__text selectState-${
              currentStateIndex !== 49 ? currentStateIndex + 1 : 0
            }-mobile`}
          >
            {nextStateName}
          </p>
        </div>
        <svg
          viewBox="0 0 30 54"
          className={`selectStateNav__icon selectStateNav__icon--reverse selectState-${
            currentStateIndex !== 49 ? currentStateIndex + 1 : 0
          }-mobile`}
          onClick={() => {
            handleClickArea(nextStateName);
          }}
        >
          <path d="M27.1484 53.3676L1.2661 28.7279L28.756 1.05926" stroke="black" />
        </svg>
      </div>
    </>
  );
}

export default SelectStateNav;
